<div class="user-management-wrapper">
  <!-- Header con título y contador -->
  <div class="um-header">
    <div class="um-header-left">
      <h3 class="font-bold mb-0">
        Gestión de Usuarios
        <span class="um-user-count" *ngIf="!loadingUsers() && countOfUsers() !== null"> ({{ countOfUsers() | number }}) </span>
        <p-skeleton
          *ngIf="loadingUsers() || countOfUsers() === null"
          width="3rem"
          height="1.25rem"
          borderRadius="4px"
          styleClass="inline-block ml-2 align-middle"
        ></p-skeleton>
      </h3>
      <span class="text-sm text-color-secondary">Administre a los miembros de Metabridge y sus permisos de acceso aquí</span>
    </div>
    <div class="um-header-right">
      <p-button label="Nuevo" icon="pi pi-plus" severity="contrast" (onClick)="configureProfileDialog()" />
    </div>
  </div>

  <!-- Barra de acciones: búsqueda + filtros -->
  <div class="um-actions">
    <div class="um-search">
      <p-iconField iconPosition="left">
        <p-inputIcon styleClass="pi pi-search" />
        <input class="w-full" type="text" pInputText placeholder="Buscar por correo..." [formControl]="searchControl" />
      </p-iconField>
    </div>
    <div class="um-filter-btn">
      <p-button
        [style]="{ width: '100%' }"
        [label]="activeFilterCount() > 0 ? 'Filtros (' + activeFilterCount() + ')' : 'Filtros'"
        [rounded]="false"
        icon="pi pi-filter"
        [outlined]="true"
        [severity]="activeFilterCount() > 0 ? 'primary' : 'secondary'"
        (onClick)="openFilterSidebar()"
      />
    </div>
  </div>

  <!-- Tabla o skeleton -->
  <div class="um-table-area">
    <div *ngIf="loadingUsers()">
      <div class="table-skeleton-container">
        <div class="skeleton-table-header">
          <div class="skeleton-cell" style="flex: 2"></div>
          <div class="skeleton-cell" style="flex: 1"></div>
          <div class="skeleton-cell" style="flex: 1.5"></div>
          <div class="skeleton-cell" style="flex: 1"></div>
          <div class="skeleton-cell" style="flex: 1.5"></div>
          <div class="skeleton-cell" style="flex: 1.5"></div>
          <div class="skeleton-cell" style="flex: 1"></div>
        </div>
        <div class="skeleton-table-body">
          <div class="skeleton-table-row" *ngFor="let i of [1, 2, 3, 4, 5]">
            <div class="skeleton-cell" style="flex: 2">
              <div class="flex items-center gap-2">
                <p-skeleton shape="circle" size="2.5rem"></p-skeleton>
                <div class="flex flex-col gap-1" style="flex: 1">
                  <p-skeleton width="60%" height="1rem"></p-skeleton>
                </div>
              </div>
            </div>
            <div class="skeleton-cell" style="flex: 1">
              <p-skeleton width="80px" height="1.5rem" borderRadius="16px"></p-skeleton>
            </div>
            <div class="skeleton-cell" style="flex: 1.5">
              <div class="flex flex-wrap gap-1">
                <p-skeleton width="70px" height="1.25rem" borderRadius="16px"></p-skeleton>
                <p-skeleton width="55px" height="1.25rem" borderRadius="16px"></p-skeleton>
              </div>
            </div>
            <div class="skeleton-cell" style="flex: 1">
              <p-skeleton width="80px" height="1.5rem" borderRadius="16px"></p-skeleton>
            </div>
            <div class="skeleton-cell" style="flex: 1.5">
              <div class="flex flex-col gap-1">
                <p-skeleton width="70%" height="0.875rem"></p-skeleton>
                <p-skeleton width="50%" height="0.875rem"></p-skeleton>
              </div>
            </div>
            <div class="skeleton-cell" style="flex: 1.5">
              <div class="flex flex-col gap-1">
                <p-skeleton width="70%" height="0.875rem"></p-skeleton>
                <p-skeleton width="50%" height="0.875rem"></p-skeleton>
              </div>
            </div>
            <div class="skeleton-cell" style="flex: 1">
              <div class="flex gap-2">
                <p-skeleton width="2rem" height="2rem" borderRadius="6px"></p-skeleton>
                <p-skeleton width="2rem" height="2rem" borderRadius="6px"></p-skeleton>
              </div>
            </div>
          </div>
        </div>
        <div class="skeleton-pagination">
          <div style="display: flex; justify-content: space-between; align-items: center; padding: 1rem; border-top: 1px solid #e1dfdd">
            <p-skeleton width="120px" height="2rem"></p-skeleton>
            <div style="display: flex; gap: 0.5rem; align-items: center">
              <p-skeleton width="2rem" height="2rem" borderRadius="4px"></p-skeleton>
              <p-skeleton width="2rem" height="2rem" borderRadius="4px"></p-skeleton>
              <p-skeleton width="2rem" height="2rem" borderRadius="4px"></p-skeleton>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="!loadingUsers()">
      <app-user-table
        [listOfOrganizations]="listOfOrganizations()"
        [listOfUsers]="filteredUsers()"
        (dataChanged)="onDataChanged()"
        (toastMessage)="onToastMessage($event)"
      ></app-user-table>
    </div>
  </div>
</div>

<!-- Sidebar de Filtros (Drawer) -->
<p-drawer [visible]="showFilterSidebar()" (visibleChange)="showFilterSidebar.set($event)" position="right" [style]="{ width: '22rem' }" header="Filtros">
  <div class="filter-sidebar-content">
    <!-- Filtro por Rol -->
    <div class="filter-section">
      <h4 class="filter-section-title">Rol</h4>
      <div class="filter-options">
        <div *ngFor="let role of availableRoles()" class="filter-option" [class.active]="filterRoles().includes(role)" (click)="toggleFilterRole(role)">
          <i class="pi" [class.pi-check-square]="filterRoles().includes(role)" [class.pi-stop]="!filterRoles().includes(role)"></i>
          <span>{{ role }}</span>
        </div>
        <span *ngIf="availableRoles().length === 0" class="text-xs text-color-secondary">Sin roles disponibles</span>
      </div>
    </div>

    <!-- Filtro por Estado -->
    <div class="filter-section">
      <h4 class="filter-section-title">Estado</h4>
      <div class="filter-options">
        <div
          *ngFor="let opt of statusOptions"
          class="filter-option"
          [class.active]="filterStatuses().includes(opt.value)"
          (click)="toggleFilterStatus(opt.value)"
        >
          <i class="pi" [class.pi-check-square]="filterStatuses().includes(opt.value)" [class.pi-stop]="!filterStatuses().includes(opt.value)"></i>
          <span>{{ opt.label }}</span>
        </div>
      </div>
    </div>

    <!-- Filtro por Servicio -->
    <div class="filter-section">
      <h4 class="filter-section-title">Servicio</h4>
      <div class="filter-options">
        <div *ngFor="let svc of availableServices()" class="filter-option" [class.active]="filterServices().includes(svc)" (click)="toggleFilterService(svc)">
          <i class="pi" [class.pi-check-square]="filterServices().includes(svc)" [class.pi-stop]="!filterServices().includes(svc)"></i>
          <span>{{ serviceDisplayNames[svc] || svc }}</span>
        </div>
        <span *ngIf="availableServices().length === 0" class="text-xs text-color-secondary">Sin servicios disponibles</span>
      </div>
    </div>

    <!-- Acciones -->
    <div class="filter-actions">
      <p-button label="Limpiar Filtros" icon="pi pi-times" severity="secondary" [outlined]="true" [style]="{ width: '100%' }" (onClick)="clearFilters()" />
      <p-button label="Aplicar Filtros" icon="pi pi-check" severity="primary" [style]="{ width: '100%' }" (onClick)="applyFilters()" />
    </div>
  </div>
</p-drawer>

<p-toast />
